// Amazon Fire TV's browser (Silk). Kept free of newer built-ins: the
// standalone TV player (src/tvPlayer) uses it on Chrome 53.
const isFireTvUserAgent = (): boolean => /\bSilk\b/.test(navigator.userAgent);

export default isFireTvUserAgent;
